<template>
  <div id="app" :dir="rtl ? 'rtl' : 'ltr'">
    <!-- Mobile Version -->
    <MobileNav class="MobileShow" />
    <!-- Desktop Version -->
    <Showcase class="MobileHide" />
    <Navbar
      class="container MobileHide"
      style="margin-bottom: 10px; margin-top: 35px"
    />
    <div class="container">
      <div class="row">
        <div class="col MobileHide">
          <GoldenButton :text="$t('LanguageEn.myTournamentsHead')" />
          <Tournaments />
          <GoldenButton :text="$t('LanguageEn.myTeamsHead')" />
          <HeaderBody />
          <Countries />
          <Leagues />
        </div>
        <!-- Middle Side -->
        <div class="col-7 MobileHide">
          <router-view :key="$route.path" />
        </div>
        <!-- Right Side -->
        <div class="col MobileHide">
          <!-- <LoginP style="margin-bottom: 10px;"/> -->
          <Balance v-if="cookiesObject.token" />
          <Gguess style="margin-bottom: 10px" />
          <router-link
            v-if="cookiesObject.token"
            style="text-decoration: none"
            id="routerLink"
            :to="{ name: 'Leaderboard', params: {} }"
          >
            <Glb style="margin-bottom: 10px" />
          </router-link>
          <Glb
            v-else
            data-toggle="modal"
            data-target="#exampleModal"
            style="cursor: pointer; margin-bottom: 10px"
          />
        </div>
      </div>
      <div
        class="footer-copyright text-center py-3 col-12 MobileHide"
        style="background: #141416; margin-top: 400px"
      >
        <div fluid style="color: grey">
          {{ $t("LanguageEn.txtCopyright") }} ©
          {{ new Date().getFullYear() }} zunisport.com |
          {{ $t("LanguageEn.txtAllRight") }}
          <a>
            <b-button
              v-b-modal.modal-F
              style="background: none; border: none; margin-bottom: 5px"
              >{{
                $t("LanguageEn.txtTermsAndConditions")
              }}
              Zunisport.com</b-button
            >
            <b-modal
              ref="tc-modal"
              header-class="tcModal"
              body-class="tcModal"
              id="modal-F"
              :title="$t('LanguageEn.txtTermsAndConditions')"
              hide-footer
            >
              <p class="my-4" v-html="terms"></p>
            </b-modal>
            <b-modal
              ref="portal-modal"
              header-class="tcModal"
              body-class="tcModal"
              id="portal-modal"
              title="Select Portal"
              hide-footer
            >
              <div class="mb-3" v-for="portal in portalData" :key="portal.id">
                <img :src="portal.logo" :alt="portal.logo" />
                <p @click="selectPortal(portal)" style="cursor: pointer">
                  {{ portal.name }}, {{ portal.countryCode }}
                </p>
              </div>
            </b-modal>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MobileNav from "./components/Mobile/MobileNav";
import Showcase from "./components/Showcase";
import GoldenButton from "./components/LeftColumn/GoldenButton";
import Countries from "./components/LeftColumn/Countries";
import HeaderBody from "./components/LeftColumn/HeaderBody";
import Tournaments from "./components/LeftColumn/Tournaments";
import Navbar from "./components/MiddleColumn/Navbar";
import Leagues from "./components/RightColumn/Leagues";
import Glb from "./components/RightColumn/Glb";
import Gguess from "./components/RightColumn/Gguess";
import Balance from "./components/RightColumn/Balance";
// import LoginP from './components/RightColumn/LoginP'

export default {
  name: "App",
  data() {
    return {
      cookiesObject: "",
      terms: "",
      poId: 1,
      laId: 1,
      portalData: "",
    };
  },

  methods: {
    ...mapActions(["getArray", "setRtl"]),
    selectPortal(portal) {
      const portalId = portal.id;
      const countryCode = portal.countryCode;

      if (portal.params.evina_enabled == 1) {
        document.cookie = "evina =" + localStorage.getItem("evina_i");
      }

      document.cookie = "portalId =" + portalId;
      document.cookie = "countryCode =" + countryCode;
      document.cookie = "langId = " + portal.params.default_language;
      document.cookie =
        "regText = " + portal.params.show_registration_intro_text;
      document.cookie = "lang = " + portal.params.default_lang_code;
      document.cookie = "lBoard =" + portal.params.leaderboard_type;
      document.cookie = "reg =" + portal.params.registration_enabled;

      location.reload();
    },
  },
  components: {
    MobileNav,
    Showcase,
    GoldenButton,
    HeaderBody,
    Navbar,
    Leagues,
    // LoginP,
    Tournaments,
    Countries,
    Glb,
    Gguess,
    Balance,
  },

  async created() {
    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;

    if (!cookiesObject.langId) {
      document.cookie = "langId = 1";
    }

    if (cookiesObject.lang == "ar") {
      this.setRtl(1);
    } else {
      this.setRtl(0);
    }

    if (cookiesObject.portalId) {
      console.log("portal ID identified");
    } else {
      if (cookiesObject.token) {
        const res = await fetch(
          "https://sportapi.zuniac.com/general/appData?token=" +
            this.cookiesObject.token
        );
        const data = await res.json();
        const portalId = data.portal.id;
        const countryCode = data.portal.countryCode;
        console.log(12, data);

        document.cookie = "lBoard =" + data.portal.params.leaderboard_type;
        document.cookie = "reg =" + data.portal.params.registration_enabled;
        document.cookie = "portalId =" + portalId;
        document.cookie = "countryCode =" + countryCode;
        document.cookie = "langId =" + data.portal.params.default_language;
        document.cookie = "lang =" + data.portal.params.default_lang_code;

        setTimeout(() => {
          location.reload();
        }, "200");
      } else {
        const res = await fetch("https://sportapi.zuniac.com/general/appData");
        const data = await res.json();

        if (data.portals.length > 1) {
          this.portalData = data.portals;
          this.$refs["portal-modal"].show();
        } else {
          const portalId = data.portals[0].id;
          const countryCode = data.portals[0].countryCode;

          if (data.portals[0].params.evina_enabled == 1) {
            document.cookie = "evina =" + localStorage.getItem("evina_i");
          }

          document.cookie = "portalId =" + portalId;
          document.cookie = "countryCode =" + countryCode;
          document.cookie =
            "langId = " + data.portals[0].params.default_language;
          document.cookie =
            "regText = " + data.portals[0].params.show_registration_intro_text;
          document.cookie =
            "lang = " + data.portals[0].params.default_lang_code;
          document.cookie =
            "lBoard =" + data.portals[0].params.leaderboard_type;
          document.cookie =
            "reg =" + data.portals[0].params.registration_enabled;

          location.reload();
        }
      }
    }
  },

  async beforeMount() {
    if (this.cookiesObject.token) {
      this.getArray();
    }

    var myHeaders = new Headers();
    myHeaders.append(
      "Cookie",
      "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765"
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      this.httpReq +
        "/general/page?languageId=" +
        (this.cookiesObject.langId ? this.cookiesObject.langId : 0) +
        "&link=terms&portalId=" +
        this.cookiesObject.portalId,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.page) {
          this.terms = result.page.text;
        } else {
          this.terms = "No information at the moment";
        }
      })
      .catch((error) => console.log("error", error));
  },
  computed: {
    ...mapGetters(["httpReq", "rtl"]),
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap");

body {
  background: #141416;
  height: 100%;
  width: 100%;
  font-family: "Roboto" !important;
}

.minWidth {
  min-width: 600px;
}
.tcModal {
  background: #212225;
  color: lightgrey;
  border: none;
  font-size: 12px !important;
}
.tcModal .modal-title {
  font-size: 15px !important;
}
.tcModal .close {
  color: white !important;
}

@media only screen and (max-width: 770px) {
  body {
    background: #212529;
  }
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}
</style>
